import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import * as Mdi from '@mdi/js';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  private readonly icons = {
    'head-snowflake-outline': Mdi.mdiHeadSnowflakeOutline,
    'account-circle-outline': Mdi.mdiAccountCircleOutline,
    logout: Mdi.mdiLogout,
    magnify: Mdi.mdiMagnify,
    plus: Mdi.mdiPlus,
    edit: Mdi.mdiPencilOutline,
    close: Mdi.mdiClose,
    arrowRight: Mdi.mdiArrowRight,
    chevronRight: Mdi.mdiChevronRight,
    chevronLeft: Mdi.mdiChevronLeft,
    play: Mdi.mdiPlay,
    pause: Mdi.mdiPause,
    stop: Mdi.mdiStopCircleOutline,
    circle: Mdi.mdiCircleMedium,
    delete: Mdi.mdiDeleteOutline,
    account: Mdi.mdiAccount,
    cellPhone: Mdi.mdiCellphone,
    watchVariant: Mdi.mdiWatchVariant,
    battery: Mdi.mdiBattery,
    chartSankeyVariant: Mdi.mdiChartSankeyVariant,
    alert: Mdi.mdiAlert,
    triangleDown: Mdi.mdiTriangleDown,
    triangleDownOutline: Mdi.mdiTriangleDownOutline,
    fileImport: Mdi.mdiFileImportOutline,
  };

  registerIcons(): void {
    Object.entries(this.icons).forEach(([name, path]) => {
      this.iconRegistry.addSvgIconLiteral(
        name,
        this.sanitizer.bypassSecurityTrustHtml(`<svg viewBox="0 0 24 24"><path d="${path}" /></svg>`),
      );
    });
  }
}
